import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom"; // Import useParams

const SSO = () => {
  const navigate = useNavigate();
  const { data } = useParams(); // Get the 'data' parameter from the URL

  useEffect(() => {
    let userData = null;
    if (data) {
      try {
        // Decode the URI component and parse the JSON string
        userData = JSON.parse(decodeURIComponent(data));
      } catch (error) {
        console.error("Failed to parse user data from URL:", error);
        // Handle parsing error, e.g., redirect to an error page or login
        return;
      }
    }

    if (userData) {
      const { user, access_token, token_type, expires_in } = userData;

      // Calculate expiration time (e.g., current time + expires_in seconds)
      const expirationTime = new Date().getTime() + expires_in * 1000;

      // Store the access token and expiration time in localStorage
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("token_type", token_type);
      localStorage.setItem("expires_in", expirationTime.toString());

      // Store user information
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("isAuthenticated", "true");

      console.log("User data and tokens stored in localStorage.");
      // redirect the user to a dashboard or home page after successful login
      navigate("/");
    }
  }, [data]); // Depend on 'data' parameter

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="loading-container">
        <img src="/favicon.ico" alt="Loading" className="loading-icon" />
        <div className="loading-text">Processing Single Sign-On...</div>
      </div>
    </div>
  );
};

export default SSO;
